import React, { useState } from "react";
import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";
import { useForm } from "react-hook-form";
import { Box, Button } from "@mui/material";
import FormTextEditor from "@/components/FormTextEditor";
import { createArticleReq } from "@/api/adminApi";
import { useNewsStore } from "@/store/newsStore.ts";
import { useAuthStore } from "@/store/authStore.ts";
import NewsDatePicker from "@/pages/NewsPage/components/NewsDatePicker.tsx";
import { ArticleTitleValidation } from "@/validators/articleTitleValidation.ts";

export type ArticleForm = {
  title: string;
  content: string;
  dateStamp: string;
};
const AddNewArticle = () => {
  const role = useAuthStore((state) => state.role);
  const isAdmin = role === "administrator";

  const createArticle = useNewsStore((state) => state.createArticle);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    reset();
    setOpen(false);
  };

  const {
    handleSubmit,
    reset,
    control,
    watch,
    formState: { isValid },
  } = useForm<ArticleForm>({
    mode: "onChange",
  });

  const title = watch("title");
  const content = watch("content");

  const onSubmit = async (data: ArticleForm) => {
    try {
      const response = await createArticleReq(data);
      createArticle(response.data?.article);
      handleClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      {isAdmin && (
        <Button
          sx={{ whiteSpace: "nowrap" }}
          onClick={() => setOpen(true)}
          variant={"contained"}
        >
          Add Article
        </Button>
      )}
      <Modal
        boxSx={{ maxWidth: "1000px" }}
        disableEnforceFocus
        open={open}
        onClose={handleClose}
        title={"Add article"}
      >
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            marginTop: "24px",
          }}
          onSubmit={handleSubmit(onSubmit)}
        >
          <Box
            sx={{ display: "flex", flexDirection: "column", overflow: "auto" }}
          >
            <FormInput
              name={"title"}
              control={control}
              label={"Title"}
              placeholder={"Write your title here..."}
              controlProps={{
                rules: {
                  required: "Required",
                  ...ArticleTitleValidation,
                },
              }}
            />
            <FormTextEditor
              name={"content"}
              control={control}
              label={"Content"}
              controlProps={{ rules: { required: "Required" } }}
            />
            <NewsDatePicker control={control} />
          </Box>
          <Box sx={{ display: "flex", paddingTop: "20px", gap: "16px" }}>
            <Button
              variant={"outlined"}
              sx={{ width: "100%" }}
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant={"contained"}
              sx={{ width: "100%" }}
              type={"submit"}
              disabled={!title || !content || !isValid}
            >
              Add
            </Button>
          </Box>
        </form>
      </Modal>
    </>
  );
};

export default AddNewArticle;
